module.exports = __webpack_public_path__ + "img/JP.690c725a.svg";